<template>
  <div>
    <div class="pileDetail">
      <div>
        <el-image :src="image" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Virtual",
  data(){
    return{
      image:require("../../../assets/images/production/virtual/虚拟电厂(1).jpg")
    }
  }
}
</script>

<style scoped>

</style>
